import { ButtonBase, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const Tarjeta_Enfoque_Servicios = ({ titulo, descripcion, servicios }) => {

    return (
        <Grid container direction="column" size={{ xs: 12 }}>
            <Grid size={{ xs: 12 }}>
                <Typography component="h3" variant="h3">
                    {titulo}
                </Typography>
            </Grid>

            {descripcion && (
                <Grid size={{ xs: 12 }} sx={{ mt: 2 }}>
                    <Typography component="p" variant="body1">
                        {descripcion}
                    </Typography>
                </Grid>
            )}

            <Grid
                container
                direction="column"
                justifyContent="flex-start"
                size={{ xs: 12 }}
                sx={{ mt: 5 }}
            >
                {servicios.map((servicio, index) => (
                    <Grid key={index} size={{ xs: 12 }} sx={{ mb: 2 }}>
                        <Link
                            to={servicio.slug}
                            aria-label={`Ver servicio: ${servicio.titulo}`}
                            style={{ textDecoration: "none" }}
                        >
                            <ButtonBase
                                component="span"
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    gap: 0.5,
                                    background: "transparent",
                                    transition: "0.3s",
                                    "&:hover": { opacity: 0.6 },
                                }}
                            >
                                <Typography
                                    component="span"
                                    sx={{
                                        fontSize: 15,
                                        fontWeight: 500,
                                        lineHeight: 1.4,
                                        color: "#223B59",
                                        textAlign: "left",
                                    }}
                                >
                                    {servicio.titulo}
                                </Typography>
                                <ArrowForwardIosIcon sx={{ fontSize: 12, color: "#223B59" }} />
                            </ButtonBase>
                        </Link>
                    </Grid>
                ))}
            </Grid>
        </Grid>
    );
};

export default Tarjeta_Enfoque_Servicios;